export default function Button({ variant = "primary", className = "", ...props }) {
  const style = variant === "secondary" ? "btn-secondary" : variant === "danger" ? "btn-danger" : "btn-primary";
  return <button className={`btn ${style} ${className}`.trim()} {...props} />;
}
